// extracted by mini-css-extract-plugin
export default {"icon":"RLSortHeader_icon__4RfqV","wrapper":"RLSortHeader_wrapper__1Rcf6"};